// extracted by mini-css-extract-plugin
export default {"heading":"LikOdS","harmony":"XA0wdi","harmonyV3":"Pg10Ci","left":"dyUMTR","right":"rFyn7G"};